import headerbom from '@components/header'
import footerbom from '@components/footer'
let components = {
    headerbom,
    footerbom
}

export default components


// WEBPACK FOOTER //
// ./src/base/api/components.js